import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["allCheckbox", "middleCheckbox", "categoryCheckbox"]

  connect() {
    this.updateCategoryCheckboxes();
  }

  checkedToggleAll(event) {
    const checked = event.target.checked
    this.middleCheckboxTargets.forEach(cb => { cb.checked = checked })
    this.categoryCheckboxTargets.forEach(cb => { cb.checked = checked })
  }

  checkedToggleMiddle(event) {
    const checked = event.target.checked;
    const section = event.target.closest('[data-job-category-list-section]');
    if (!section) return;
    const checkboxes = section.querySelectorAll('input[type="checkbox"][data-job-category-list-target="categoryCheckbox"]');
    checkboxes.forEach(cb => {
      if (cb) cb.checked = checked;
      cb.dispatchEvent(new Event("change", { bubbles: true }));
    });
    this.updateCategoryCheckboxes();
  }

  updateCategoryCheckboxes() {
    this.middleCheckboxTargets.forEach(middleCheckbox => {
      const section = middleCheckbox.closest('[data-job-category-list-section]');
      if (!section) return;
      const checkboxes = section.querySelectorAll('input[type="checkbox"][data-job-category-list-target="categoryCheckbox"]');
      middleCheckbox.checked = checkboxes.length > 0 && Array.from(checkboxes).some(cb => cb.checked);
    });

    if (this.hasAllCheckboxTarget) {
      this.allCheckboxTarget.checked = this.categoryCheckboxTargets.length > 0 && this.categoryCheckboxTargets.every(cb => cb.checked);
    }
  }
}
